import {
  AddBusinessCustomerV2ComboboxKey,
  AddBusinessCustomerV2FormData,
  AddBusinessCustomerV2FormKey,
} from './types'

export const BUSINESS_USE_CASES: Record<string, string> = {
  fiat: 'FIAT',
  crypto: 'CRYPTO',
  stablecoinPayouts: 'STABLECOIN_PAYOUTS',
  embeddedStablecoinWallets: 'EMBEDDED_STABLECOIN_WALLETS',
  embeddedFiatAccounts: 'EMBEDDED_FIAT_ACCOUNTS',
}

export const ENTITY_TYPES: Record<string, string> = {
  corporation: 'CORPORATION',
  limitedLiabilityCompany: 'LIMITED_LIABILITY_COMPANY',
  publiclyListedCompany: 'PUBLICLY_LISTED_COMPANY',
  soleProprietor: 'SOLE_PROPRIETOR',
  partnership: 'PARTNERSHIP',
  trust: 'TRUST',
}

export const MONTHLY_EXPECTED_VOLUMES: Record<string, string> = {
  under100k: 'UNDER_100K',
  from100kTo1m: 'FROM_100K_TO_1M',
  from1mTo10m: 'FROM_1M_TO_10M',
  from10mTo100m: 'FROM_10M_TO_100M',
  over100m: 'OVER_100M',
}

export const BUSINESS_SOURCE_OF_FUNDS: Record<string, string> = {
  commercialActivities: 'COMMERCIAL_ACTIVITIES',
  shareholderCapital: 'SHAREHOLDER_CAPITAL',
  ventureCapital: 'VENTURE_CAPITAL',
  saleOfAssets: 'SALE_OF_ASSETS',
  cryptoFundraising: 'CRYPTO_FUNDRAISING',
  cryptoTradingRevenue: 'CRYPTO_TRADING_REVENUE',
  corporateLoans: 'CORPORATE_LOANS',
  other: 'OTHER',
}

export const BUSINESS_INTENDED_USE_OF_ACCOUNT: Record<string, string> = {
  supplierVendorPayments: 'SUPPLIER_VENDOR_PAYMENTS',
  intercompanyTransfers: 'INTERCOMPANY_TRANSFERS',
  payroll: 'PAYROLL',
  customerPaymentsReceived: 'CUSTOMER_PAYMENTS_RECEIVED',
  customerPayoutsRefundsSettlements: 'CUSTOMER_PAYOUTS_REFUNDS_SETTLEMENTS',
  operatingExpenses: 'OPERATING_EXPENSES',
  dividendProfitDistributions: 'DIVIDEND_PROFIT_DISTRIBUTIONS',
  loanRepaymentFinancialActivities: 'LOAN_REPAYMENT_FINANCIAL_ACTIVITIES',
}
export const COMBOBOX_KEYS: AddBusinessCustomerV2ComboboxKey[] = [
  'useCase',
  'entityType',
  'taxResidenceCountryCode',
  'monthlyExpectedVolumes',
  'sourceOfFunds',
  'intendedUseOfAccount',
  'registeredAddressCountryCode',
  'operationalAddressCountryCode',
]

export const RADIO_KEYS: AddBusinessCustomerV2FormKey[] = [
  'isRegulated',
  'isOperationalAddressDifferent',
]

export const ADD_BUSINESS_CUSTOMER_V2_DEFAULT_VALUES: AddBusinessCustomerV2FormData = {
  useCase: '',
  name: '',
  entityType: '',
  registrationNumber: '',
  taxNumber: '',
  taxResidenceCountryCode: '',
  naicsCode: '',
  monthlyExpectedVolumes: '',
  isRegulated: '',
  sourceOfFunds: '',
  intendedUseOfAccount: '',
  registeredAddressLine1: '',
  registeredAddressCity: '',
  registeredAddressPostalCode: '',
  registeredAddressCountryCode: '',
  isOperationalAddressDifferent: '',
  operationalAddressLine1: '',
  operationalAddressCity: '',
  operationalAddressPostalCode: '',
  operationalAddressCountryCode: '',
}
